export default __webpack_public_path__ + "static/media/quneitra.f017599e.jpg";